import { motion, AnimatePresence } from "framer-motion";
import { POGZILLA_HERO, DYNO_HERD } from "@/lib/mapConstants";

// 🦖 DYNO STAMPEDE — a herd of POGZILLAs charge across (easter egg + siege victory).
export const DynoStampede = ({ active }) => (
  <AnimatePresence>
    {active && (
      <>
        {/* roar flash */}
        <motion.div
          className="absolute inset-0 z-[1835] pointer-events-none"
          initial={{ opacity: 0 }} animate={{ opacity: [0, 0.4, 0, 0.25, 0] }} exit={{ opacity: 0 }}
          transition={{ duration: 1.1, times: [0, 0.12, 0.3, 0.42, 1] }}
          style={{ background: "radial-gradient(circle at 50% 65%, rgba(52,211,153,0.55), transparent 68%)" }}
        />
        <motion.div
          data-testid="pogzilla-banner"
          initial={{ opacity: 0, y: -20, scale: 0.8 }} animate={{ opacity: 1, y: [0, -3, 0], scale: 1 }} exit={{ opacity: 0, scale: 0.8 }}
          transition={{ y: { duration: 0.4, repeat: 8, repeatType: "mirror", ease: "easeInOut" } }}
          className="absolute top-24 sm:top-28 left-1/2 -translate-x-1/2 z-[1850] glass-strong border border-emerald-400/40 rounded-full px-5 py-2 shadow-2xl pointer-events-none"
        >
          <span className="font-heading font-extrabold text-base sm:text-lg bg-gradient-to-r from-sky-400 to-emerald-400 bg-clip-text text-transparent tracking-tight">🦖 DYNO STAMPEDE! 🦖</span>
        </motion.div>
        {DYNO_HERD.map((d, i) => (
          <motion.img
            key={i}
            data-testid={i === 0 ? "pogzilla-stomp" : `dyno-${i}`}
            src={POGZILLA_HERO}
            alt="POGZILLA"
            initial={{ x: "-60vw", opacity: 0 }}
            animate={{ x: "130vw", opacity: 1, y: [0, -d.jump, 0, -d.jump, 0, -d.jump, 0] }}
            exit={{ opacity: 0 }}
            transition={{
              x: { duration: d.dur, ease: "linear", delay: d.delay },
              opacity: { duration: 0.25, delay: d.delay },
              y: { duration: d.dur, ease: "easeInOut", delay: d.delay, times: [0, 0.16, 0.33, 0.5, 0.66, 0.83, 1] },
            }}
            className="absolute left-0 z-[1840] h-auto object-contain drop-shadow-[0_0_26px_rgba(52,211,153,0.5)] pointer-events-none select-none"
            style={{ width: d.w, bottom: `calc(${d.bottom} + env(safe-area-inset-bottom))` }}
          />
        ))}
      </>
    )}
  </AnimatePresence>
);
